import { Row } from '@tanstack/react-table';
import cx from 'classnames';
import styles from '../Table.module.scss';
import { ChevronDownIcon, ChevronUpIcon } from '@/components/base/Icons/RocheIconPack';
import { useCallback } from 'react';

type RowExtensionHandleProps<T> = {
  row: Row<T>;
  rowExtensionEnabled: boolean;
  onToggleRow: (row: Row<T>) => void;
  rowExpandedDelayed: Record<string, boolean>;
};

const RowExtensionHandle = <T,>({
  row,
  rowExtensionEnabled,
  onToggleRow,
  rowExpandedDelayed,
}: RowExtensionHandleProps<T>) => {
  if (!rowExtensionEnabled) return null;

  const isExpanded = row.getIsExpanded() && (rowExpandedDelayed[row.id] ?? false);
  const ExtensionIcon = isExpanded ? ChevronUpIcon : ChevronDownIcon;
  const handleClick = useCallback(() => onToggleRow(row), [row]);
  return (
    <td
      onClick={handleClick}
      className={cx({
        [styles.rowExtensionToggle]: true,
        [styles.rowToggler]: true,
        [styles.open]: isExpanded,
        [styles.sticky]: true,
        rowExtensionHandle: true,
      })}
    >
      <ExtensionIcon className="rowExtensionHandle" width="2rem" />
    </td>
  );
};

export default RowExtensionHandle;
